import React, { useEffect, useRef , useState } from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import TruncateTooltip from "@/components/truncate-with-tooltip";

import UIPopper from "@/components/popover";
import moment from "moment";
import AvatarDefault from "@/components/avatar";
import { colorEnums } from "@/modules/crm/dashboard/helper";
import ShowMorePopper from "@/components/calendar/show-more-popper";
import { useSelector } from "react-redux";
import { getCalendars } from "@/store/slices/appointment/appointmentSlice";

const commonStyles = {
  width: 18,
  height: 18,
  minWidth: 10,
  minHeight: 10,
  fontSize: "0.6rem",
};
export const DayEvent = ({
  event,
  contextMenuOptions = null,
  onHover = false,
  popOverComp = () => {},
  onEventClick,
  showAvatar,
  onSelectEvent,
}) => {
  const calendars = useSelector(getCalendars) || [];
  const resolvedCalendar = calendars.find(
    (c) => c.uuid === event?.calendarId || c.calendarId === event?.calendarId
  );
  const hostMember = resolvedCalendar?.members?.find(
    (m) =>
      m.id === event?.participantId ||
      m.id === event?.memberId ||
      m.memberId === event?.participantId ||
      m.memberId === event?.memberId ||
      m.userId === event?.participantId ||
      m.userId === event?.memberId
  );
  const hostName = hostMember?.name || resolvedCalendar?.members?.[0]?.name || event?.organizer || "N/A";
  const guestName = event?.name || event?.guest || event?.email || "N/A";
  const [anchorEl, setAnchorEl] = useState(null);
  const hiddenEvents = event._overlaps || [];
  const handleMouseEnter = (event) => {
    console.log("enter");
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    console.log("leave");
    setAnchorEl(null);
  };

  const checkPast = (dt) => {
    if (moment(dt).isBefore(moment())) {
      return { textDecoration: "line-through" };
    } else {
      return {};
    }
  };

  const parentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (parentRef.current) {
      setHeight(parentRef.current.offsetHeight);
    }
  }, []);

  const tooltipAvatar = (comp) => (
    <Tooltip
      arrow
      title={
        <Box>
          <Typography
            sx={{ fontSize: "0.9rem", fontWeight: "600" }}
            color={"primary"}
          >
            Host:{" "}
            <Typography
              component={"span"}
              sx={{ fontSize: "0.8rem", color: "var(--palette-grey_text)" }}
            >
              {hostName}
            </Typography>
          </Typography>
          <Typography
            sx={{ fontSize: "0.9rem", fontWeight: "600" }}
            color={"primary"}
          >
            Guest:{" "}
            <Typography
              component={"span"}
              sx={{ fontSize: "0.8rem", color: "var(--palette-grey_text)" }}
            >
              {guestName}
            </Typography>
          </Typography>
        </Box>
      }
      placement="top-start"
      PopperProps={{
        sx: {
          "& .MuiTooltip-tooltip": {
            maxWidth: 170,
          },
        },
      }}
    >
      {comp}
    </Tooltip>
  );

  return (
    <>
      <Box
        ref={parentRef}
        sx={{ height: "100%", margin: "auto 1px" }}
        // sx={{ height: "100%" }}
        className="d-flex align-items-center justify-content-space-between"
      >
        <Box
          className="d-flex align-items-center"
          // aria-hidden="false"
          // onMouseLeave={handleMouseLeave}
          sx={{
            width: "100%",
            justifyContent: hiddenEvents.length
              ? "flex-start"
              : "space-between",
          }}
        >
          <Box
            className={height <= 25 ? "d-flex" : ""}
            sx={{ px: height <= 25 ? "" : "5px" }}
          >
            {onHover ? (
              <PopoverComp popOverComp={popOverComp} event={event} />
            ) : (
              <Box
                {...(onEventClick
                  ? { onClick: () => onEventClick(event) }
                  : {})}
              >
                <TruncateTooltip
                  limit={18}
                  text={event?.title}
                  sx={{
                    fontSize: "0.8rem",
                    display: "block",
                    fontWeight: "500",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "1",
                    color:
                      event?.color?.textCode || "var(--palette-primary_button)",
                    // ...checkPast(event?.start),
                  }}
                />
              </Box>
            )}
            <Typography
              component="span"
              sx={{
                fontSize: "0.75rem",
                lineHeight: "normal",
                color: event?.color?.textCode || "var(--palette-grey_text)",
                // ...checkPast(event?.start),
              }}
            >
              {height <= 25 ? " - " : ""}
              {moment(event?.start).format("h:mm A")} - {moment(event?.end).format("h:mm A")}
            </Typography>
          </Box>
          {showAvatar &&
            !event?.isBusy &&
            tooltipAvatar(
              <Box
                className="d-flex align-items-center"
                sx={{ position: "relative", ml: "20px" }}
              >
                <AvatarDefault
                  name={hostName}
                  avatarStyles={{
                    ...commonStyles,
                    background: colorEnums.green.text,
                    color: colorEnums.green.bg,
                  }}
                />
                <AvatarDefault
                  name={guestName}
                  avatarStyles={{
                    ...commonStyles,
                    background: colorEnums.purple.text,
                    color: colorEnums.purple.bg,
                    position: "absolute",
                    right: "16px",
                  }}
                />
              </Box>
            )}
        </Box>
        {hiddenEvents.length ? (
          <ShowMorePopper
            clickNodeSX={{
              minWidth: "max-content",
              fontSize: "0.8rem",
              fontWeight: "600",
              padding: "2px 5px",
              margin: "1px",
            }}
            title={`+${hiddenEvents.length} more`}
            events={hiddenEvents}
            contextMenuOptions={contextMenuOptions}
            popOverComp={popOverComp}
            onHover={onHover}
            onSelectEvent={onSelectEvent}
          />
        ) : null}

        {/* <Box className="d-flex align-items-center justify-content-space-between"> */}
        {/* {contextMenuOptions && (
          <GridActionPopover
            clickNodeStyles={{
              background: event?.color?.code || "none",
              color: event?.color?.textCode || "var(--palette-primary_button)",
              padding: 0,
              fontSize: "1rem",
              "&:hover": {
                backgroundColor: "none",
              },
            }}
            options={contextMenuOptions(event)}
          />
        )} */}
        {/* </Box> */}
      </Box>
    </>
  );
};

export const DayEventStyling = (event, start, end, isSelected) => {
  // var backgroundColor = '#' + event.hexColor;
  var style = {
    backgroundColor: event?.color?.code || "#BCAAFF",
    borderRadius: "5px",
    // color: "#281A66",
    color: event?.color?.textCode || "var(--palette-primary_button)",
    height: "40px",
    padding: "0px 5px !important",
    // border: "1px solid #A085FE",
  };
  return {
    className: `custom-resource-event`,
    style: style,
  };
};

export const PopoverComp = ({ popOverComp, event }) => {
  return (
    <div style={{ cursor: "pointer" }}>
      <UIPopper
        paperStyles={{ p: 1 }}
        anchorOrigin={{ vertical: "center", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        paperClasses=""
        clickNode={<span>{event.title}</span>}
      >
        {({ setAnchorEl }) => {
          return <Box>{popOverComp({ event, setAnchorEl })}</Box>;
        }}
      </UIPopper>
    </div>
  );
};

export const AutoHeightTimeSlot = ({ children, value }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "1px", // allow shrinking
      }}
    >
      {children}
    </div>
  );
};
